// extracted by mini-css-extract-plugin
export default {"weeks":"styles_weeks__W81nR","one_week":"styles_one_week__yjt7A"};